import { GetEventVideoInput } from '../../../API';
import { GetEventVideoQuery, QueryOutputType } from '../../../common/type/QueryType';
import { graphqlOperationWithTokenRefresh } from '../../../common/api/graphqlOperation';

/**
 * イベント映像一覧取得用のクエリ
 */
const query = /* GraphQL */ `
	query GetEventVideo($offsegInput: GetEventVideoInput!, $g500LiteInput: GetEventVideoInput!) {
		getOffsegEventVideo(input: $offsegInput) {
			responseType
			message
			eventVideos {
				occurrenceDatetime
				organizationName
				driverName
				carCode
				numberPlate
				eventType
				gValue
				hiyariLevel
				hiyariResult
				legalSpeed
				overspeed
			}
		}
		getG500LiteEventVideo(input: $g500LiteInput) {
			responseType
			message
			eventVideos {
				occurrenceDatetime
				organizationName
				driverName
				carCode
				numberPlate
				eventType
				gValue
				hiyariLevel
				hiyariResult
				legalSpeed
				overspeed
			}
		}
	}
`;

/**
 * イベント映像一覧取得APIを呼び出す
 */
export const queryGetEventVideo = async (
	offsegInput: GetEventVideoInput,
	g500LiteInput: GetEventVideoInput,
	authorizationToken: string,
): Promise<QueryOutputType<GetEventVideoQuery>> => {
	const apiResponse = await graphqlOperationWithTokenRefresh<GetEventVideoQuery>(
		query,
		{ offsegInput: offsegInput, g500LiteInput: g500LiteInput },
		authorizationToken,
	);
	console.log(apiResponse);

	return apiResponse;
};
